"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePesquisaPaginadaParams = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useSearchParams_1 = require("./useSearchParams");
const react_redux_1 = require("react-redux");
const pesquisa_1 = require("../../store/ducks/pesquisa");
const const_1 = require("../const");
const usePesquisaPaginadaParams = () => {
    const { search: locationSearch } = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const _a = (0, react_redux_1.useSelector)((state) => state.pesquisa), { consulta } = _a, _b = _a.opcoesResultado, { paginaAtiva, quantPag, ordenacaoCombo, ordenacao } = _b, restOpcoesResultado = __rest(_b, ["paginaAtiva", "quantPag", "ordenacaoCombo", "ordenacao"]);
    const [filterParams, setFilterParams] = (0, react_1.useState)();
    const { getAllSearchParams, setSearchParam, removeSearchParam, clearSearchParams, } = (0, useSearchParams_1.useSearchParams)();
    const params = (0, react_1.useMemo)(() => {
        const allParams = getAllSearchParams();
        return {
            page: allParams.page ? parseInt(allParams.page, 10) : null,
            perPage: allParams.perPage
                ? parseInt(allParams.perPage, 10)
                : null,
            orderBy: allParams.orderBy || null,
            direction: allParams.direction || null,
        };
    }, [locationSearch]);
    (0, react_1.useEffect)(() => {
        const allParams = getAllSearchParams();
        const filters = Object.keys(allParams).filter(key => key.startsWith('f') && key.length === 2);
        const newFilters = filters.reduce((acc, key) => {
            return Object.assign(Object.assign({}, acc), { [key]: allParams[key] });
        }, {});
        const hasChanges = !(JSON.stringify(filterParams) === JSON.stringify(newFilters));
        if (!hasChanges)
            return;
        setFilterParams(newFilters);
    }, [locationSearch]);
    (0, react_1.useEffect)(() => {
        const hasParamsChanges = params.page && params.page !== paginaAtiva ||
            params.orderBy && params.orderBy !== quantPag ||
            params.orderBy && params.orderBy !== ordenacaoCombo ||
            params.direction && params.direction !== ordenacao;
        if (!consulta ||
            (consulta !== 'error' &&
                consulta.searchVersion === const_1.VERSAO_PESQUISA_PAGINADA &&
                hasParamsChanges)) {
            dispatch((0, pesquisa_1.changeOpcoesResultado)(Object.assign(Object.assign({}, restOpcoesResultado), { paginaAtiva: params.page || 1, quantPag: params.perPage || 20, ordenacaoCombo: params.orderBy || false, ordenacao: params.direction || false })));
        }
    }, [params]);
    const setPage = (page) => {
        if (!page) {
            removeSearchParam('page');
            return;
        }
        setSearchParam('page', `${page}`);
    };
    const setPerPage = (perPage) => {
        if (!perPage) {
            removeSearchParam('perPage');
            return;
        }
        setSearchParam('perPage', `${perPage}`);
    };
    const setOrderBy = (orderBy) => {
        if (!orderBy) {
            removeSearchParam('orderBy');
            return;
        }
        setSearchParam('orderBy', `${orderBy}`);
        setSearchParam('page', '1');
    };
    const setDirection = (direction) => {
        if (!direction) {
            removeSearchParam('direction');
            return;
        }
        setSearchParam('direction', `${direction}`);
        setSearchParam('page', '1');
    };
    const addFilter = (key, value) => {
        if (!filterParams)
            return;
        const current = filterParams[key];
        if (current) {
            setSearchParam(key, `${current},${value}`);
        }
        else {
            setSearchParam(key, value);
        }
        setPage(1);
    };
    const removeFilter = (key, value) => {
        if (!filterParams)
            return;
        const current = filterParams[key]; // Ex: pode vir algo como "4%252C1"
        if (current) {
            const decoded = decodeURIComponent(decodeURIComponent(current)); //  deixa no formato"4,1"
            const values = decoded.split(',').map(v => v.trim());
            const index = values.indexOf(value);
            if (index !== -1) {
                values.splice(index, 1);
                if (values.length === 0) {
                    removeSearchParam(key);
                }
                else {
                    // re-encode properly
                    const joined = values.join(',');
                    const encoded = encodeURIComponent(joined); // "4,1" → "4%2C1"
                    setSearchParam(key, encoded);
                }
            }
        }
        setPage(1);
    };
    const clearFilters = () => {
        let allParams = getAllSearchParams();
        const keysToRemove = Object.keys(allParams).filter(key => key.startsWith('f') && key.length === 2);
        keysToRemove.forEach(key => delete allParams[key]);
        clearSearchParams(new URLSearchParams(Object.entries(allParams).map(([key, value]) => [
            key,
            value,
        ])));
    };
    return {
        params,
        filterParams,
        setPage,
        setPerPage,
        setOrderBy,
        setDirection,
        addFilter,
        removeFilter,
        clearFilters,
    };
};
exports.usePesquisaPaginadaParams = usePesquisaPaginadaParams;
